import {InputGroup, Spinner, SpinnerSize} from "@blueprintjs/core";
import { showError } from "nsitools-react";
import * as React from "react";

import { TranslationsApi, UpdateTranslationCommand } from "../../api";
import { useApiService } from "../../hooks";

export interface ITranslationEditorProps {
  translationId: number;
  initialTextValue: string;
}
export const TranslationTextEditor: React.FunctionComponent<ITranslationEditorProps> = ({
  initialTextValue,
  translationId,
}) => {
  const [currentValue, setCurrentValue] = React.useState<string>();
  const [editedValue, setEditedValue] = React.useState<string>();

  React.useEffect(() => {
    setCurrentValue(initialTextValue);
    setEditedValue(initialTextValue);
  }, [initialTextValue]);

  const [loading, setLoading] = React.useState(false);
  const api = useApiService(TranslationsApi);
  const onBlur = React.useCallback(
    async (e: any) => {
      if (editedValue !== currentValue) {
        try {
          setLoading(true);
          await api.updateTranslation(new UpdateTranslationCommand({ text: editedValue, translationId }));
          setCurrentValue(editedValue);
        } catch (Error) {
          showError(`Unable to save translation ${translationId}`);
          setEditedValue(currentValue);
        }
        setLoading(false);
      }
    },
    [api, currentValue, editedValue, translationId],
  );

  return (
    <InputGroup
      style={{ borderRadius: "none" }}
      value={editedValue}
      onChange={(e) => setEditedValue(e.target.value)}
      onBlur={onBlur}
      rightElement={loading ? <Spinner size={SpinnerSize.SMALL} /> : null}
    />
  );
};
